import type { NavigateFunction } from 'react-router-dom';

/**
 * 해시태그 클릭 시 검색 이동 (기기별 자연스러운 UX로 분기).
 * - PC: 속닥속닥 목록 화면에서 검색창 키워드로 검색 (?search=)
 * - 모바일: 별도 검색 화면(/search)으로 이동 (탭=속닥속닥 'post')
 */
export const goToHashtagSearch = (navigate: NavigateFunction, isMobile: boolean, tag: string) => {
    const q = encodeURIComponent(tag);
    if (isMobile) {
        navigate(`/search?q=${q}&tab=post`);
    } else {
        navigate(`/posts?search=${q}`);
    }
};
